import { type Appointment } from 'types/appointments';

export const AppointmentsSectionMode = {
  future: 'future',
  past: 'past',
} as const;

export interface AppointmentsSectionProps {
  appointments: Appointment[];
  isLoading: boolean;
  title: string;
  emptyMessage: string;
  mode?: (typeof AppointmentsSectionMode)[keyof typeof AppointmentsSectionMode];
}
